import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

import {Handler} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonContent} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonContent';
import {ChromelessButton} from '../../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../../../../libs/shared/ui/src/styles/paletteModel';
import {makeMapStateToProps} from '../../../../../../helpers/reselectHelpers';
import {CompanyModel, defaultCompanyName} from '../../../../../../models/api/companyModel';
import {getCompany} from '../../../../../../store/data/company/companySelectors';
import {CompanyAvatar} from '../../../../../common/avatars/companyAvatar';

/*
 * Props.
 */

interface AssignDropdownAddTeammateCardProps {
  onClick: Handler;
  company: CompanyModel;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  padding: 5px;
`;

type StyleProps = {
  $shouldCenter: boolean;
};
const StyledContentDiv = styled.div<StyleProps>`
  margin: 0 auto;
  background-color: ${(p) => p.theme.palette.blue.shade10};
  border-radius: 4px;
  padding: 6px 13px 4px 8px;
  display: flex;
  justify-content: ${(p) => (p.$shouldCenter ? 'center' : null)};
  align-items: center;
`;

const StyledTextWrapperDiv = styled.div`
  padding-left: 8px;
`;

const StyledDescriptionDiv = styled.div`
  letter-spacing: -0.154px;
  color: ${(p) => p.theme.greys.shade80};

  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.verySmall};
  display: flex;
  padding-bottom: 2px;
`;

const StyledButtonWrapperDiv = styled.div<StyleProps>`
  display: flex;
  justify-content: ${(p) => (p.$shouldCenter ? 'center' : null)};
`;

const StyledButtonContent = styled(ButtonContent)`
  margin-left: -5px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.normal};
`;

/*
 * Component.
 */

export const AssignDropdownAddTeammateCard: FC<AssignDropdownAddTeammateCardProps> = (props) => {
  const {onClick, company} = props;
  const shouldRenderAvatar = company.name !== defaultCompanyName;

  return (
    <StyledWrapperDiv>
      <StyledContentDiv $shouldCenter={!shouldRenderAvatar}>
        {shouldRenderAvatar && <CompanyAvatar size={30} company={company} />}
        <StyledTextWrapperDiv>
          <StyledDescriptionDiv>
            <Trans id="assign-dropdown-addteammate-description">Front is more impactful with a team</Trans>
          </StyledDescriptionDiv>
          <StyledButtonWrapperDiv $shouldCenter={!shouldRenderAvatar}>
            <ChromelessButton onClick={onClick} interactionId="assign-dropdown-addteammate-click">
              <StyledButtonContent
                variant={ButtonVariantsEnum.LINK}
                size={VisualSizesEnum.SMALL}
                color={PaletteColorsEnum.BLUE}
              >
                <Trans id="assign-dropdown-addteammate-button">
                  Invite people to {shouldRenderAvatar ? company.name : 'your company'}
                </Trans>
              </StyledButtonContent>
            </ChromelessButton>
          </StyledButtonWrapperDiv>
        </StyledTextWrapperDiv>
      </StyledContentDiv>
    </StyledWrapperDiv>
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  company: getCompany,
}));

export const AssignDropdownAddTeammateCardContainer = connect(mapStateToProps)(AssignDropdownAddTeammateCard);
